import { FormattedAddress } from "components/address";
import { AdminLayout } from "components/admin/admin-layout";
import { SubscriberDetails } from "components/admin/Subscription/SubscriberDetails";
import { Button } from "components/buttons/button";
import { Spinner } from "components/spinner";
import {
  GetSubscriptionObjectForCmsQueryResult,
  useGetSubscriptionObjectForCmsQuery,
} from "lib/graphql-generated";
import { parseParam } from "lib/utils";
import { useRouter } from "next/router";

export type SubscriptionSubscriber =
  GetSubscriptionObjectForCmsQueryResult["data"]["subscription_object_by_pk"];

export const SubscriptionObjectPage = () => {
  const router = useRouter();
  const id = parseParam(router.query["id"]);
  const { data, loading, error } = useGetSubscriptionObjectForCmsQuery({
    variables: { id: id },
    skip: !id,
  });

  const subscriptionObject = data?.subscription_object_by_pk;

  return (
    <AdminLayout page='Subscription'>
      <article className='space-y-4'>
        <header className='flex flex-row justify-between'>
          <h1 className='header text-4xl'>Subscriber</h1>
          <section>
            <Button
              buttonType='secondary'
              buttonSize='md'
              href={`/manage-subscription/${subscriptionObject?.short_id}`}>
              Customer Management Portal
            </Button>
          </section>
        </header>
        {loading || (!data && !error) ? (
          <Spinner />
        ) : !data || error ? (
          <>Could not find Subscription </>
        ) : (
          <SubscriberDetails subscriptionObject={subscriptionObject} />
        )}
      </article>
    </AdminLayout>
  );
};

export default SubscriptionObjectPage;
